<template>
  <div class="donator_step1">
   <div class="container">
   	<div class="row">
   		<div class="col-md-6 offset-md-3">
        <h3>Stap 1</h3>
   			<h1>Uw bijdrage</h1>
        <p>Kies het bedrag en de periode dat u wilt doneren.</p>
   		   <div class="form-group">
            <div v-on:click="setAmount(5)" class="button" v-bind:class="{'active': amount5 }">&euro;5</div>
            <div v-on:click="setAmount(10)" class="button" v-bind:class="{'active': amount10 }">&euro;10</div>
            <div v-on:click="setAmount(20)" class="button" v-bind:class="{'active': amount20 }">&euro;20</div>
            <div v-on:click="setAmount(25)" class="button" v-bind:class="{'active': amount25 }">&euro;25</div>
            <div v-on:click="setAmount(50)" class="button" v-bind:class="{'active': amount50 }">&euro;50</div>
          </div>
          <div class="form-group">
            <input type="text" name="amount" id="amount" placeholder="Anders.." class="form-control" v-model="amount">
          </div>
   				<div class="form-group">
   					<label for="name" >Periode:</label>
   					<select name="period" id="period" class="form-control" v-model="period" >
   						<option value="maandelijks">Maandelijks</option>
              <option value="jaarlijks">Jaarlijks</option>
   					</select>
   				</div>

   				<router-link :to="{ name: 'Donator_step2', params: { amount: amount, period: period } }"><button>Volgende stap</button></router-link>
   			
   		</div>
   	</div>
   </div>
  </div>
</template>

<script>
export default {
  name: 'Donator_step1',
  data(){
    return {
      amount: '',
      period: '',
      amount5: false,
      amount10: false,
      amount20: false,
      amount25: false,
      amount50: false,
      research: []
    }
  },
  methods: {
    setAmount : function(amount){
      this.amount = amount;
      switch(amount){
        case 5:
        this.amount5 = true;
          break;
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/donator/Step1.vue